import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export class BackstagePos extends DataModel {
  static readonly TYPE_ID: string = '96bc0825a60b40aca93a5a05797bc8ed';

  private constructor(
    public readonly uniqueId: string,
    public readonly baseUrl: string,
    public readonly posName: string,
    public readonly certificateId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return BackstagePos.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static create(args: {
    uniqueId: string,
    baseUrl: string,
    posName: string,
    certificateId: string,
  }): BackstagePos {
    return new BackstagePos(
        args.uniqueId,
        args.baseUrl,
        args.posName,
        args.certificateId,
    );
  }

  static fromData(
      context: SerializationContext,
      map: SerializedData,
  ): BackstagePos {
    return new BackstagePos(
        MapUtils.getString(map, 'uniqueId'),
        MapUtils.getString(map, 'baseUrl'),
        MapUtils.getString(map, 'posName'),
        MapUtils.getString(map, 'certificateId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'baseUrl': this.baseUrl,
      'posName': this.posName,
      'certificateId': this.certificateId,
    };
  }

  clone(): this {
    return new BackstagePos(
        this.uniqueId,
        this.baseUrl,
        this.posName,
        this.certificateId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
      other.baseUrl === this.baseUrl &&
      other.posName === this.posName &&
      other.certificateId === this.certificateId;
  }
}

export class BackstagePosBuilder extends DataModelBuilder<BackstagePos> {
  build(context: SerializationContext, map: SerializedData): BackstagePos {
    return BackstagePos.fromData(context, map);
  }
}
